import { HostListener, Injectable } from '@angular/core';
import { AppModule } from '@app/app.module';
import { ModalController, PopoverController } from '@ionic/angular';
import { TEMPLATE_WIDTH_CHANGE } from '@shared-libs/constants';
import { Template } from '@shared-libs/enums';
import { BackgroundColorService } from '@shared-services/background-color.service';
import { ValidationService } from '@shared-services/validation.service';
import { cloneDeep } from 'lodash';

@Injectable()
export class BasePage {
	public template: Template;
	public readonly backgroundColor: string;
	private previousTemplate: Template;
	private readonly backgroundColorService: BackgroundColorService;
	private readonly validationService: ValidationService;
	private readonly modalController: ModalController;
	private readonly popoverController: PopoverController;

	constructor() {
		this.validationService = AppModule.injector.get(ValidationService);
		this.backgroundColorService = AppModule.injector.get(BackgroundColorService);
		this.modalController = AppModule.injector.get(ModalController);
		this.popoverController = AppModule.injector.get(PopoverController);
		this.setTemplate(window.innerWidth);
	}

	@HostListener('window:resize', ['$event'])
	public onResize(): void {
		this.previousTemplate = cloneDeep(this.template);
		this.setTemplate(window.innerWidth);
	}

	private setTemplate(width: number): void {
		/* if (this.previousTemplate !== this.template) {
			void this.closeAllOpenModalsAndPopovers().catch();
		} */
		if (width < TEMPLATE_WIDTH_CHANGE || this.validationService.isOnMobile()) {
			this.template = Template.mobile;
		} else this.template = Template.desktop;
	}

	private async closeAllOpenModalsAndPopovers(): Promise<void> {
		while (await this.modalController.getTop()) {
			await this.modalController.dismiss();
		}
		while (await this.popoverController.getTop()) {
			await this.popoverController.dismiss();
		}
	}

	private ionViewWillEnter(): void {
		this.backgroundColorService.setBackgroundColor(this.backgroundColor);
	}

	private ionViewWillLeave(): void {
		this.backgroundColorService.resetBackgroundColor();
	}
}
